import { getFullName, getInitialsFromName } from "utils";

import type { ShipmentTemplate } from "types/shipment";

export interface TemplateSharerBadge {
  initials: string;
  tooltip: string;
}

export function getTemplateSharerBadge(
  template: ShipmentTemplate,
): TemplateSharerBadge | null {
  const sharer = template.shared_by?.user;
  if (!template.was_shared_with_me || !sharer) return null;
  return {
    initials: getInitialsFromName(
      getFullName(sharer.first_name, sharer.last_name),
    ),
    tooltip: `Shared by ${getFullName(sharer.first_name, sharer.last_name)}`,
  };
}

export function getShipmentTemplateVisibiliyLabel(
  template: ShipmentTemplate,
): string | null {
  if (template?.content?.direct_booking) {
    return "Direct Booking";
  }
  if (
    template?.content?.notification_settings_type &&
    (template?.content?.notification_settings_type === "ALL_CARRIER_NETWORK" ||
      template?.content?.notification_settings_type ===
        "SELECTED_NETWORK_CARRIERS")
  ) {
    return "Public";
  }
  if (
    template?.content?.notification_settings_type &&
    (template?.content?.notification_settings_type === "PRIVATE_SHIPMENT" ||
      template?.content?.notification_settings_type ===
        "PRIVATE_SHIPMENT_ALL_NETWORK")
  ) {
    return "Private";
  }
  return null;
}
